/**
 * Application Bootstrap
 *
 * Wires the app's auth store into the shared api client (the client itself is
 * app-state-agnostic — see lib/api.ts configureApiAuth), then seeds the auth +
 * preferences stores from the server-injected bootstrap island (W4 B3) so the
 * app has user context before the first /api/me fetch resolves.
 *
 * Imported and awaited by main.tsx before the app renders.
 */
import { configureApiAuth } from '@marine/api-client/api';
import { authStore } from '@/state/auth';
import { usePreferencesStore } from '@/state/preferences';
import type { PreferencesTree } from '@/types/preferences';
import type { User } from '@/types/auth';
import { readBootstrap } from '@/lib/readBootstrap';

configureApiAuth(() => {
  const s = authStore.getState();
  return { logout: s.logout };
});

export const bootstrap = async (): Promise<void> => {
  const data = readBootstrap();
  if (!data?.user) return;
  try {
    authStore.getState().setUser(data.user as unknown as User);
    usePreferencesStore.getState().setAll((data.preferences ?? {}) as PreferencesTree);
  } catch {
    // Island seeding failed — app falls back to the /api/me fetch.
  }
};
